import { Controller } from '@hotwired/stimulus';
import { useCollectionEventListeners, useEventListener, useMutationObserver } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = ['saveBtn', 'navBtn', 'savedMessage'];

  get inputs() {
    return Array.from(
      this.element.querySelectorAll('input, select, trix-editor, textarea'),
    );
  }

  initialize() {
    this.showSaveButton = this.showSaveButton.bind(this);
    this.hideSaveButton = this.hideSaveButton.bind(this);
    this.mutationObserved = this.mutationObserved.bind(this);
  }

  connect() {
    useCollectionEventListeners(this, this.inputs, ['change', 'keyup', 'keydown'], this.showSaveButton);
    useEventListener(this, this.element, 'submit', this.hideSaveButton);
    useMutationObserver(
      this,
      this.element,
      this.mutationObserved,
      { childList: true, subtree: true },
    );
  }

  mutationObserved(entries) {
    entries.forEach((entry) => {
      if (entry.addedNodes.length > 0) {
        entry.addedNodes.forEach((node) => {
          if (node.nodeName === 'INPUT' || node.nodeName === 'SELECT' || node.nodeName === 'TRIX-EDITOR' || node.nodeName === 'TEXTAREA') {
            useEventListener(this, node, ['change', 'keyup', 'keydown'], this.showSaveButton);
          } else {
            const inputs = Array.from(node.querySelectorAll('input, select, trix-editor, textarea'));
            useCollectionEventListeners(this, inputs, ['change', 'keyup', 'keydown'], this.showSaveButton);
          }
        });
      }
      if (entry.removedNodes.length > 0) {
        entry.removedNodes.forEach((node) => {
          if (node.nodeName === 'INPUT' || node.nodeName === 'SELECT' || node.nodeName === 'TRIX-EDITOR' || node.nodeName === 'TEXTAREA') {
            this.showSaveButton();
          } else {
            const inputs = Array.from(node.querySelectorAll('input, select, trix-editor, textarea'));
            if (inputs.length > 0) {
              this.showSaveButton();
            }
          }
        });
      }
    });
  }

  showSaveButton(e) {
    if (e && (e.code === 'Enter' || e.code === 'ArrowUp' || e.code === 'ArrowDown' || e.code === 'ArrowLeft' || e.code === 'ArrowRight')) {
      return;
    }

    this.saveBtnTargets.forEach((btn) => {
      btn.disabled = false;
      btn.classList.remove('hidden');
    });

    this.navBtnTargets.forEach((btn) => btn.classList.add('opacity-0', 'pointer-events-none'));
  }

  hideSaveButton() {
    this.saveBtnTargets.forEach((btn) => {
      btn.disabled = true;
      btn.classList.add('hidden');
    });

    this.savedMessageTarget.classList.remove('hidden');
    this.navBtnTargets.forEach((btn) => btn.classList.remove('opacity-0', 'pointer-events-none'));

    setTimeout(() => this.savedMessageTarget.classList.add('hidden'), 2500);
  }
}
